import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TaxAttributesComponent } from '../tax-attributes.component';

@Component({
    selector: 'app-tax-attributes-nested-nol',
    templateUrl: './tax-attributes-nested-nol.component.html',
    styleUrls: ['../tax-attributes.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TaxAttributesNestedNolComponent {
  @Input() ctx!: TaxAttributesComponent;
}
